{
  "user-profile": {
    "buttons": {
      "confirm-email": "Confirmer l'email",
      "confirm-phone-nr": "Confirmer le numéro de téléphone",
      "update": "Mise à jour",
      "update-password": "Mise à jour du mot de passe",
      "update-phone-nr": "Mise à jour du numéro de téléphone"
    },
    "text": {
      "communication": "Communication",
      "communication-hint": "La plupart des salons utilisent le e-mail pour communiquer (par exemple pour les confirmations de rendez-vous), mais certains offrent également la possibilité d'utiliser le SMS. Préféreriez-vous recevoir des SMS dans ces cas-là ?",
      "confirm-email": "Veuillez confirmer votre e-mail",
      "confirm-phone-nr": "Veuillez confirmer votre numéro de téléphone",
      "contact-data": "Données de contact",
      "in-second": "en {{seconds}} s",
      "password": "Mot de passe",
      "personal-data": "Données personnelles",
      "pin-code": "Code PIN",
      "pin-code-hint": "Veuillez définir tous les {{ numberOfPinDigit }} à mettre à jour. Ce code PIN est utilisé uniquement pour se connecter aux applications Beauty Checkin et Beauty Checkout.",
      "update-password-by-email": "Le code PIN vous sera envoyé par e-mail. Vous aurez besoin de ce code PIN pour confirmer votre nouveau mot de passe.",
      "update-password-by-sms": "Le code PIN vous sera envoyé par SMS. Vous aurez besoin de ce code PIN pour confirmer votre nouveau mot de passe.",
      "update-success": "Mise à jour réussie !",
      "via-email": "Non",
      "via-sms": "Oui"
    }
  }
}
